// Only `off` and `on` are valid values for the `autoComplete` attribute on a form element.
//
// For more information, see:
// - [MDN documentations on `form.autocomplete`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form#autocomplete

/**
 * Normalize the value of the `autoComplete` attribute for a form element.
 */
export function normalizeAutocomplete(value) {
  if (value === true) {
    return 'on';
  } else if (value === false) {
    return 'off';
  }
  return undefined;
}

// Submit the form using the native validation and submit behavior
// by calling `form.requestSubmit`. We don't call `onSubmit` directly
// within the keyDownHandler because it would not have the correct event object.
// We also don't use `form.submit` because it does not raise a submit event
// and so would not trigger the `onSubmit` handler.
//
// For more information, see:
//
// - [MDN documentation on `form.submit`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/submit),
// - [MDN documentation on `form.requestSubmit`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/requestSubmit).

/**
 * Submit the form using the native validation and submit behavior.
 */
export function requestSubmit(form) {
  form.requestSubmit();
}